import { useEffect } from 'react'

/**
 * Hook to manage page titles across the application
 * @param section - The section name (e.g., "Lightspeed", "Xero", etc.)
 * @param page - The specific page name (e.g., "Sales Export", "Products Export", etc.)
 * @param skipSection - If true, only shows page name without section prefix
 */
export function usePageTitle(section?: string, page?: string, skipSection = false) {
  useEffect(() => {
    const appName = 'Evo Platform Toolkit'
    let title = appName
    
    if (page) {
      if (section && !skipSection) {
        title = `${section} - ${page} | ${appName}`
      } else {
        title = `${page} | ${appName}`
      }
    }
    
    document.title = title
    
    // Cleanup: reset to default title when component unmounts
    return () => {
      document.title = appName
    }
  }, [section, page, skipSection])
}

export default usePageTitle